import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Text, View } from 'react-native';
import { MAC_BROWSER_CANVAS_HTML, macBrowserInput } from '@/lib/macBrowserCanvas';

const SOURCE = { html: MAC_BROWSER_CANVAS_HTML };
export default function MacBrowserCanvas({ wsRef, userControl, frame }) {
  // Loaded only on Mac. Web builds keep their ordinary DOM input surface.
  const { WebView } = require('react-native-webview');
  const web = useRef(null);
  const [ready, setReady] = useState(false);
  const [inputError, setInputError] = useState(false);
  const validFrame = typeof frame === 'string' && frame.length <= 8 * 1024 * 1024 && /^[A-Za-z0-9+/]*={0,2}$/.test(frame) ? frame : null;
  useEffect(() => {
    if (ready) web.current?.injectJavaScript(`window.gabBrowserFrame(${JSON.stringify(validFrame)},${userControl && !!validFrame});true;`);
  }, [ready, userControl, validFrame]);
  const onMessage = useCallback(event => {
    const message = macBrowserInput(event.nativeEvent?.data);
    if (message?.kind === 'ready') { setReady(true); return; }
    if (message?.kind === 'input_error') { setInputError(true); return; }
    const ws = wsRef.current;
    if (message && userControl && validFrame && ws?.readyState === WebSocket.OPEN) {
      if (['text', 'key'].includes(message.kind)) setInputError(false);
      ws.send(JSON.stringify({ type: 'input', ...message }));
    }
  }, [wsRef, userControl, validFrame]);
  return <View style={{ flex: 1, width: '100%' }}><WebView ref={web} source={SOURCE} style={{ flex: 1, width: '100%' }} containerStyle={{ flex: 1, width: '100%' }}
    accessibilityLabel="Cloud browser viewport" onMessage={onMessage}
    onLoadStart={() => setReady(false)} onLoadEnd={() => setReady(true)}
    originWhitelist={['*']} onShouldStartLoadWithRequest={request => request.url === 'about:blank'}
    onOpenWindow={() => {}} javaScriptCanOpenWindowsAutomatically={false}
    incognito cacheEnabled={false} sharedCookiesEnabled={false} useSharedProcessPool={false}
    allowFileAccess={false} allowFileAccessFromFileURLs={false} allowUniversalAccessFromFileURLs={false}
    allowsLinkPreview={false} />
    {inputError && <Text accessibilityRole="alert" style={{ color: '#fff', backgroundColor: '#333', padding: 10 }}>Paste is limited to 16,384 characters. Paste a smaller selection.</Text>}
  </View>;
}
